import React from 'react';
import '../../styles/components/Banner.css';
import Navbar from './Navbar';

const Banner = () => {
    return (
    <div className='Header-container'>
        <Navbar />
        <div className='Banner'>
            {/* Compact hero — the page-level chat FAB handles "ask me anything"
                discovery, so the hero stays informational and lets the projects
                section pull up into the fold. */}
            <div className='Banner--content'>
                <h1 className='Banner--heading'>
                    <span className='Banner--name'>Hi, I'm Chidrupa Mamunooru.</span>
                    <span className='Banner--role'>
                        <span className='Banner--ai-sparkle' aria-hidden='true'>✨</span>{' '}
                        An <span className='Banner--ai-emphasis'>AI-first</span> Designer.
                    </span>
                </h1>

                <p className='Banner--subhead'>
                    Designing and shipping products at the edge of UX, code, and AI.
                </p>

                <div className='Banner--experience'>
                    <span>5+ years experience</span>
                    <span>•</span>
                    <span>Bally's, Schrodinger, Deloitte, Ourdate, ASU</span>
                </div>
            </div>
        </div>
    </div>
    )
}

export default Banner;
